"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callFinalStatuses = exports.callStatuses = void 0;
var callStatuses;
(function (callStatuses) {
    callStatuses["PENDING"] = "pending";
    callStatuses["ONGOING"] = "ongoing";
    callStatuses["PERFORMED"] = "performed";
    callStatuses["ON_HOLD"] = "onHold";
    callStatuses["TIMED_OUT"] = "timedOut";
    callStatuses["CANCELED"] = "canceled";
    callStatuses["TEMPORARILY_SUSPENDED"] = "temporarilySuspended";
})(callStatuses || (exports.callStatuses = callStatuses = {}));
var callFinalStatuses;
(function (callFinalStatuses) {
    callFinalStatuses["PERFORMED"] = "performed";
    callFinalStatuses["CANCELED"] = "canceled";
})(callFinalStatuses || (exports.callFinalStatuses = callFinalStatuses = {}));
